require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-schliesstage-geschl-jahr-0-3-j-2020-21.json") })
        }
      }, "path---kriterien-schliesstage-geschl-jahr-0-3-j-2020-21");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-schliesstage-geschl-jahr-0-3-j-2020-21!./.cache/json/kriterien-schliesstage-geschl-jahr-0-3-j-2020-21.json
// module id = 1090
// module chunks = 231608221292675